import { ExtendedUserResponse } from "../generated/ups/graphql";
import { pick } from "./pick";

export const transform = (users: ExtendedUserResponse[]) => {
  return users.map((user) => ({
    ...pick(user, [
      "username",
      "firstName",
      "lastName",
      "email",
      "status",
      "lastLogin",
      "attributes",
    ]),
    groups: user.groups?.join(", ") ?? "",
    roles: user.roles?.join(", ") ?? "",
  }));
};
